module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp13_6005.c8558f1f.png";